import React, { useState, useRef, useEffect } from 'react';
import './OrderNowButton.css';

const OrderNowButton = ({ theme = 'dark', deliveryLinks = {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Default delivery links if none provided
  const defaultLinks = {
    doordash: 'https://www.doordash.com/store/31519661/?srsltid=AfmBOoqYon2m4LRWcESWHYqI-4c2NaNPEau9oIf2tBfRkhZuAQm7ZD65',
    grubhub: 'https://www.grubhub.com/restaurant/highlands-sports-bar--grill-644-laurel-st-san-carlos/9493104'
  };

  const links = {
    ...defaultLinks,
    ...deliveryLinks
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`order-now-container ${theme}`} ref={dropdownRef}>
      <button 
        className="order-now-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        Order Now
        <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>
      
      {isOpen && (
        <div className="delivery-dropdown" role="menu">
          <a 
            href={links.doordash}
            target="_blank"
            rel="noopener noreferrer"
            className="delivery-option"
            role="menuitem"
          >
            DoorDash
          </a>
          {links.ubereats && (
            <a 
              href={links.ubereats}
              target="_blank"
              rel="noopener noreferrer"
              className="delivery-option"
              role="menuitem"
            >
              Uber Eats
            </a>
          )}
          <a 
            href={links.grubhub}
            target="_blank"
            rel="noopener noreferrer"
            className="delivery-option"
            role="menuitem"
          >
            GrubHub
          </a>
        </div>
      )}
    </div>
  );
};

export default OrderNowButton; 